import { jsx } from "react/jsx-runtime";
import ApartmentIcon from "@mui/icons-material/Apartment";
import { validateTidalLicense } from "../../base/index.js";
function Apartment(props) {
  return /* @__PURE__ */ jsx(
    ApartmentIcon,
    {
      "data-testid": "Apartment",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Apartment",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Apartment.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Apartment"
};
validateTidalLicense();
export {
  Apartment
};
//# sourceMappingURL=Apartment.js.map
